import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import { TitanIconComponent, IconSize } from '../titan-icon/titan-icon.component';
import { CarouselModule } from "ngx-owl-carousel-o";

export const IconButtonVariants = {
  Primary: 'primary',
  Secondary: 'secondary',
  Base: 'base',
  BaseLarge: 'base-l',
  NeutralBase: 'neutral-base',
  NeutralBaseLarge: 'neutral-base-l',
} as const;

export type IconButtonVariant = typeof IconButtonVariants[keyof typeof IconButtonVariants];

@Component({
  selector: 'app-titan-icon-button',
  standalone: true,
  templateUrl: './titan-icon-button.html',
  imports: [
    NgClass,
    NgIf,
    TitanIconComponent,
    CarouselModule
],
  styleUrls: ['./titan-icon-button.scss']
})
export class TitanIconButtonComponent {

  @Input() isDisabled = false;
  @Output() onPress = new EventEmitter<void>();
  @Input() variant: IconButtonVariant = IconButtonVariants.Primary;
  @Input() iconVariant: string;
  @Input() iconSize: IconSize = 'm';

  handleButtonClick() {
      this.onPress.emit();
  }
}
